/**
 * Wrapper mínimo sobre react-katex. Permite `<Math display>{tex}</Math>`
 * (block) ou `<Math>{tex}</Math>` (inline).
 */

import 'katex/dist/katex.min.css'
import { BlockMath, InlineMath } from 'react-katex'

interface Props {
  children: string
  display?: boolean
}

export function Math({ children, display = false }: Props) {
  return display ? <BlockMath math={children} /> : <InlineMath math={children} />
}
